var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-input',{attrs:{"type":"area","rows":_vm.rows,"label":_vm.label,"disabled":_vm.disabled}})}
var staticRenderFns = []

export { render, staticRenderFns }